import { createServerFn } from "@tanstack/react-start";

import { cmsRegistry } from "@/content/cmsRegistry";
import type { LegalPage } from "@/content/legal";
import { contentSource } from "@/content/source";

const resolve = cmsRegistry<LegalPage>({
  // Through `contentSource()`, whose dynamic import keeps the CMS client out
  // of the client chunk, see `content/landing/source.ts`.
  load: async () => (await contentSource()).loadLegalPages(),
  keyOf: (page) => page.slug,
});

/**
 * One legal or company page's content, from the CMS.
 *
 * A server function rather than a plain loader call: a route loader re-runs in
 * the browser on client-side navigation, where the CMS client is not shipped.
 */
export const legalPageContent = createServerFn({ method: "GET" })
  .inputValidator((slug: unknown): string => String(slug ?? ""))
  .handler(({ data }): Promise<LegalPage | undefined> => resolve(data));
